import Registration from '@/account/Registration.vue';
import LoginForm from '@/account/components/LoginForm.vue';
import AdSearchHome from '@/ad/components/AdSearchHome.vue'

export default {
  components: {
    Registration,
    LoginForm,
    AdSearchHome
  },
};
